




import { Component, Vue, Prop } from 'vue-property-decorator';
import mavonEditor from 'mavon-editor';

const marked = mavonEditor.markdownIt;
marked.set({ breaks: false });

@Component
export default class MarkedText extends Vue {
  @Prop({required: true, default: () => ''}) private content!: string;
  get markedContent() {
    if (this.content) {
      return marked.render(this.content);
    } else {
      return '';
    }
  }
}
